<template>
  <div class="alert-box" @click.stop="">
    <!--<el-collapse-transition>-->
      <div class="cantent size12 color33 animated zoomIn" style="animation-duration: 200ms">
        <div class="title size12 head" v-show="state === 'shipper'">
          <span >{{$t('page.choose_carrier')}}</span>
          <i class="close el-icon-close size16" @click.stop="close"></i>
        </div>
        <div class="main">
          <div v-show="state === 'quick'">
            <el-row type="flex" justify="space-between" class="size14 marBott10">
              <el-row>
                <i class="iconfont iconsousuo color26"></i>
                {{$t('page.home_c')}}
              </el-row>
              <div class="color26 pointer" @click="close">- {{$t('page.home_eee')}}</div>
            </el-row>
            <order-search ref="orderSearch" :shipperData="shipperData" @changeState="changeState" @seachOrder="seachOrder"></order-search>
          </div>
          <shippers-window
            @shippers-close="shippersClose"
            @backQuick="backQuick"
            v-if="state === 'shipper'">
          </shippers-window>
        </div>
      </div>
    <!--</el-collapse-transition>-->

  </div>
</template>

<script>
import orderSearch from '../orderSearch.vue'
import shippersWindow from '../shippersWindow.vue'
// import { changeSetting } from '@/api/getSetting'
import LocalStorage from '../../common/localStorage.js'
export default {
  components: {
    orderSearch,
    shippersWindow
  },
  data () {
    return {
      state: 'quick',
      shipperData: {}
    }
  },
  created () {

  },
  methods: {
    close () {
      this.state = 'quick'
      this.$emit('close', false)
    },
    changeState (state) {
      this.state = state
    },
    seachOrder (list) {
      this.$emit('quickSearch', list)
    },
    shippersClose () {
      this.state = 'quick'
      this.shipperData = LocalStorage.get('shippers-choose')
      if (this.shipperData) {
        this.$refs.orderSearch.changeShipper(this.shipperData)
      }
    },
    backQuick () {
      this.state = 'quick'
    }
  }
}
</script>

<style scoped>
@import '../../../static/common-css/detail.css';
  .alert-box .cantent{
    width: 820px;
    position: relative;
  }
  .alert-box .head{
    height: 55px;
    line-height: 55px;
  }
  .alert-box .title .close {
    right: 22px;
    top: 19px;
  }
  .head {
    background-color: #1F2A33!important;
    color: #fff!important;
  }
  .infoTit {
    margin: 0px 0 20px;
  }
  .el-icon-close {
    color: #fff!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/new/quickQueryAlert.vue